<template>
    <div class="main">
        <div class="container">
            <NameDisplay @click="$emit('changeName')" />
            <rect-btn
                shadow-color="rgba(171, 203, 216, 0.5)"
                background-color="#dfffe3"
                height="95px"
                width="100%"
                font-size="1.5em"
                font-weight="bold"
                @click="onClick('Stage_Select', { type: 'game1' })"
            >
                <div class="button-content">
                    <img src="@/assets/Home/icon1.png" alt="" />
                    <div class="text">含醣食物<MBr m />大挑戰</div>
                </div>
            </rect-btn>
            <rect-btn
                shadow-color="rgba(171, 203, 216, 0.5)"
                background-color="#fedec7"
                height="95px"
                width="100%"
                font-size="1.5em"
                font-weight="bold"
                @click="onClick('Stage_Select', { type: 'game2' })"
            >
                <div class="button-content">
                    <img src="@/assets/Home/icon2.png" alt="" />
                    <div class="text">糖尿病知識<MBr m />大挑戰</div>
                </div>
            </rect-btn>
            <rect-btn
                v-if="!isInEvent"
                shadow-color="rgba(171, 203, 216, 0.5)"
                background-color="#daf0ff"
                height="95px"
                width="100%"
                font-size="1.5em"
                font-weight="bold"
                @click="onClick('Stage_Tower', { type: 'game1', level: '1' })"
            >
                <div class="button-content">
                    <img src="@/assets/Home/icon3.png" alt="" />
                    <div class="text">闖關進度塔</div>
                </div>
            </rect-btn>
            <rect-btn
                v-if="!isInEvent"
                shadow-color="rgba(171, 203, 216, 0.5)"
                background-color="#cacfe5"
                height="95px"
                width="100%"
                font-size="1.5em"
                font-weight="bold"
                @click="onClick('Stage_Comics_Menu', { type: 'game1', level: '1' })"
            >
                <div class="button-content">
                    <img src="@/assets/Home/icon4.png" alt="" />
                    <div class="text">不猶豫翻翻樂</div>
                </div>
            </rect-btn>
            <rect-btn
                shadow-color="rgba(171, 203, 216, 0.5)"
                background-color="#EFE3E7"
                height="95px"
                width="100%"
                font-size="1.5em"
                font-weight="bold"
                @click="openLink('https://findtheegg.com.tw/game/game_start')"
            >
                <div class="button-content">
                    <img src="@/assets/Home/icon5.png" alt="" />
                    <div class="text">糖心蛋自我檢測</div>
                </div>
            </rect-btn>
            <div v-if="user && !isInEvent" class="group">
                <div v-if="user.group">
                    <div class="label">你的群組</div>
                    <div class="display">
                        <div class="current">
                            {{
                                (user.group && user.group.name) ||
                                "尚未加入任何群組"
                            }}
                        </div>
                        <div class="change" @click="$emit('open')">更改</div>
                    </div>
                </div>
                <div v-else>
                    <div class="display join-group" @click="$emit('open')">
                        加入群組
                    </div>
                </div>
            </div>
            <div v-if="user" class="group">
                <div
                    class="display join-group"
                    @click="$emit('leave-event')"
                    v-if="isInEvent"
                >
                    退出活動
                </div>
                <div
                    v-else
                    class="display join-group"
                    @click="$emit('join-event')"
                >
                    加入活動
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import NameDisplay from '@/components/General/NameDisplay.vue';
import MBr from '@/components/MBr.vue';

export default {
    components: { NameDisplay, MBr },
    props: {
        onClick: Function,
    },
    computed: {
        ...mapState({
            user: (state) => state.user,
        }),
        ...mapGetters(['isInEvent']),
    },
    methods: {
        openLink(url) {
            window.open(url, '_blank');
        },
    },
};
</script>

<style lang="scss" scoped>
.main {
    padding: 20px 0;
    .container {
        padding: 0 26px 0 26px;
        box-sizing: border-box;
        width: 100%;
        > * {
            width: 100%;
            margin-bottom: 20px;
            &:last-child {
                margin-bottom: 0;
            }
        }
    }
    .button-content {
        display: flex;
        align-items: center;
        width: 100%;
        img {
            margin: 0 15px;
            width: 70px;
            height: 70px;
            border-radius: 50%;
        }
        .text {
            flex: 0.9;
        }
    }
    .group {
        width: 100%;
        > div {
            margin: auto;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            font-weight: bold;
            color: #4683bc;
            font-size: 18px;
        }
        .display {
            background-color: #cbebff;
            width: 100%;
            height: 50px;
            margin-top: 10px;
            border-radius: 18.8px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 20px;

            .current {
                flex: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 85%;
                font-size: 24px;
            }
            .change {
                cursor: pointer;
                color: #888;
            }
            &.join-group {
                cursor: pointer;
                margin-top: 0;
                justify-content: center;
                font-size: 24px;
            }
        }
    }
}
</style>
